import TrackerManager from '../../utils/TrackerManager';
import {
    AAF_CONTENT_IS_NPVR,
    AAF_CONTENT_IS_VOD,
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TV,
} from './../../AAFPlayer/constants';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import Metadata from '../../requests/apa/Metadata';
import Utils from '../../utils/Utils';
import { Dates } from '../../packages/dates';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import store from '../../store';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import { showModal, MODAL_INACTIVITY, MODAL_PIN } from '../../actions/modal';
import { setDataPlay } from '../../actions/modalInactivity';
import { DEFAULT_VALUES_REDUCE } from 'src/components/Modal/constants/ModalInactivity/index'

const skip_seconds = Metadata.get('skip_seconds', 60);
const playerSettings = {
    slideTime: skip_seconds / 4,
    backwardTime: skip_seconds / 6, // 10 hacía atrás
    stepBackwardTime: skip_seconds / 4, // 15 hacía atrás
    fastBackwardTime: skip_seconds / 2, // 30 hacía atrás
    forwardTime: skip_seconds / 6, // 10 hacía adelante
    stepForwardTime: skip_seconds / 4, // 15 hacía adelante
    fastForwardTime: skip_seconds / 2, // 30 hacía adelante
    inactivityTime: skip_seconds / 3,
    // Timeshift
    backwardTime_timeshift: skip_seconds * 3, // 3 hacía atrás
    stepBackwardTime_timeshift: skip_seconds * 10, // 10 Mins hacía atrás
    forwardTime_timeshift: skip_seconds * 3, // 3 Mins hacía adelante
    stepForwardTime_timeshift: skip_seconds * 10, // 10 Mins hacía adelante
    slideTime_timeshift: skip_seconds * 3, // intervalos de 3 mins forward/backward
};

const setPgm = (pgm) => {
    currentPgm = Pgm;
};

const onPlay = (streamContentType) => {
    console.log('[NPC] onPlay');
};

const onPause = (streamContentType) => {
    console.log('[NPC] onPause');
};

const onBackward = (streamContentType) => {
    calculateFinalSeekTime(false, playerSettings.forwardTime);
    AAFPlayer;
    console.log('[NPC] onBackward');
};

const onForward = (streamContentType) => {
    console.log('[NPC] onForward');
};

const onRecording = (streamContentType) => {
    console.log('[NPC] onRecording');
};

const onSlide = (e, streamContentType) => {
    console.log('[NPC] onSlide', e, streamContentType);
};

const sendMetric = (
    action,
    label = null,
    dataMetric,
    setMetricsEvent,
    isAudio = false,
    currentTimeMinutes,
    durationMinutes,
    eventCategory = 'reproductor tv'
) => {
    const pgm = TrackerManager.getDataPgm();

    try {
        dataMetric.title = store.getState().resume.title;
        dataMetric.provider = pgm.response.group.common.extendedcommon.media.proveedor.nombre;
    } catch (e) {
        console.log('[NPC] Send Metric TV');
    }

    if (typeof setMetricsEvent === 'function') {
        if (isAudio) {
            if (label === null) {
                label = DeviceStorage.getItem('label-music-analytics');
            }
            if (action === 'volver') {
                action = `${action}/${currentTimeMinutes}/${durationMinutes}`;
            }
            setMetricsEvent({
                hitType: 'event',
                eventCategory: 'acciones',
                eventAction: action,
                eventLabel: label,
            });
        } else {
            let provedor;
            const { provider } = dataMetric;
            const meta = Utils.getApaMetadataKey('transactional_configuration', '{}');
            const prov =
                meta &&
                meta.suscription &&
                meta.suscription.products &&
                meta.suscription.products[provider];
            if (label === null) {
                if (prov && prov[0] && prov.length === 1 && typeof prov[0] === 'string') {
                    provedor = prov[0];
                } else {
                    provedor = 'suscripcion';
                }
                label = `${provedor} - ${dataMetric.title}`;
            }

            if (action === 'volver') {
                action = `${action}/${currentTimeMinutes}/${durationMinutes}`;
            }
            if (action === 'cambiar episodio') {
                const t = dataMetric.title.split(':');
                label = `${t[0]} - ${label}`;
            }

            const metricsEvent = {
                hitType: 'event',
                eventCategory: eventCategory,
                eventAction: action,
                eventLabel: label,
            };

            setMetricsEvent(metricsEvent);
        }

        setMetricsEvent({ type: 'executor' });
        PlayerControlsLogic.sendDimension(setMetricsEvent);
    }
};

const sendDimension = (setMetricsEvent) => {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    setMetricsEvent(payload);
    setMetricsEvent({ type: 'executor' });
};

const hasTimeshift = (epgData) => {
    if (epgData && epgData.epg) {
        return epgData.event && !isNaN(epgData.event.max_timeshift);
    } else {
        return epgData.timeshiftAllowed && this.state.epg.timeshiftAllowed > 0 ? true : false;
    }
};

const withTimeshiftEvent = (epgData) => {
    return hasTimeshift() && epgData && epgData.event;
};

const getDurationAsString = (duration) => {
    if (!duration) return '00:00:00';

    return new Dates({ hours: 0, minute: 0, seconds: 0 }).add(duration, 's').format('HH:mm:ss');
};

const getContentDuration = (duration, streamContentType) => {
    let _duration = '';

    switch (streamContentType) {
        case AAF_CONTENT_IS_VOD:
        case AAF_CONTENT_IS_TV:
        case AAF_CONTENT_IS_STARTOVER:
        case AAF_CONTENT_IS_CATCHUP:
            _duration = getDurationAsString(duration);
            break;
        case AAF_CONTENT_IS_NPVR:
            break;
        default:
            break;
    }

    return _duration;
};

const getPercentProgressEvent = (eventDateStart, eventDateEnd, eventDuration) => {
    const limit_forward = eventDateEnd - Utils.nowAsTimestampSeconds();
    const dur_limit_forward = eventDateEnd - eventDateStart - limit_forward;
    const percent = dur_limit_forward > 0 ? (dur_limit_forward * 100) / eventDuration : 0;

    return percent <= 100 ? percent : 100;
};

const getPercentProgress = (currentTime, duration) => {
    if (duration < 1) return 0;
    const percent = currentTime > 0 ? (currentTime * 100) / duration : 0;

    return percent <= 100 ? percent : 100;
};

const getDatesArg = (tdate) => {
    if (isNaN(tdate)) {
        // 2020/07/31 05:00:00
        // 0    5  8  11 14 17

        const years = tdate.substring(0, 4);
        const months = tdate.substring(5, 7);
        const date = tdate.substring(8, 10);
        const hours = tdate.substring(11, 13);
        const minute = tdate.substring(14, 16);
        const seconds = tdate.substring(17, 19);

        return new Dates({ years, months, date, hours, minute, seconds });
    } else {
        return new Dates().unix(tdate);
    }
};

/* Startover */
const getCurrentTimeAsStringStartover = (currentTime, timeshiftEventInfo) => {
    if (timeshiftEventInfo && timeshiftEventInfo.event) {
        // 2020/07/31 05:00:00
        const dateBegin = getDatesArg(timeshiftEventInfo.event.date_begin);

        let ct = EpgPersistence.needsOffset()
            ? dateBegin
                  .add(currentTime, 's')
                  .utcOffset(EpgPersistence.needsOffset(), false)
                  .format('HH:mm:ss')
            : dateBegin.add(currentTime, 's').format('HH:mm:ss');

        return ct;
    }

    return '00:00:00';
};

/* Startover */
const getDurationAsStringStartover = (timeshiftEventInfo) => {
    if (timeshiftEventInfo && timeshiftEventInfo.event) {
        // 2020/07/31 05:00:00
        const dateEnd = getDatesArg(timeshiftEventInfo.event.date_end);

        return EpgPersistence.needsOffset()
            ? dateEnd.utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm:ss')
            : dateEnd.format('HH:mm:ss');
    }

    return '00:00:00';
};

//Control de modal "¿Sigues aquí?"

const DEFAULT_VALUES_INTERVAL = {
    default: DEFAULT_VALUES_REDUCE,
};

const setValueStatePlaying = (values) => {
    store.dispatch(setDataPlay(values));
};

const intervalValuesMetadata = () => {
    const data = Metadata.get(
        'continuePlayback_modal_config',
        JSON.stringify(DEFAULT_VALUES_INTERVAL)
    );
    const dataDefault = JSON.parse(data).default;

    const dataDefaultMilliseconds = {
        ...DEFAULT_VALUES_REDUCE,
        enable: dataDefault.enable,
        totalEpisodes: dataDefault.totalEpisodes,
        totalTimePlayer: dataDefault.totalTimePlayer * 60000,
        modalActiveTime: dataDefault.modalActiveTime * 60000,
        returnPath: dataDefault.returnPath,
        inactivityPath: dataDefault.inactivityPath
    };

    const region = DeviceStorage.getItem('region');
    const dataRegion = JSON.parse(data)[region];
    const dataRegionMilliseconds = dataRegion
        ? {
            ...DEFAULT_VALUES_REDUCE,
            enable: dataRegion.enable,
            totalEpisodes: dataRegion.totalEpisodes,
            totalTimePlayer: dataRegion.totalTimePlayer * 60000,
            modalActiveTime: dataRegion.modalActiveTime * 60000,
            returnPath: dataRegion.returnPath,
            inactivityPath: dataRegion.inactivityPath
          }
        : null;

    const dataReturn = dataRegionMilliseconds || dataDefaultMilliseconds;
    setValueStatePlaying(dataReturn);
    return dataReturn;
};

const resetDataModalSleep = () => {
    intervalValuesMetadata()
};

const showModalSleep = ({ play, exit, clearLoading, toggleEPG }) => {
    store.dispatch(
        showModal({
            modalType: MODAL_INACTIVITY,
            modalProps: {
                play,
                exit,
                setValueStatePlaying: setValueStatePlaying,
                resetDataModalSleep,
                clearLoading,
                toggleEPG,
            },
        })
    );
};

const setIntervalModalReproduction = ({ pause = null, play = null, exit, clearLoading= ()=>{}, toggleEPG=()=>{}}) =>
    setInterval(() => {
        const { controlTime, enable, totalTimePlayer, episodesCount, totalEpisodes } = store.getState().modalInactivity;
        const { modalType } = store.getState().modal;

        const isPlayerPlayingModalPin = AAFPlayer.isPlayerPlaying()
        const isModalPinActive = modalType === MODAL_PIN;

        const nowTime = new Date().getTime();
        const showModalTime = nowTime - controlTime;
        const checkTimeAndEpisodes = showModalTime >= totalTimePlayer || episodesCount > totalEpisodes
        console.log('🚀 ~ file: [MODAL_INACTIVITY]: EJECUTANDO REVISIÓN')

        if (enable && checkTimeAndEpisodes && isPlayerPlayingModalPin) {
            const choiceClearLoading = isModalPinActive ? clearLoading : ()=>{};
            showModalSleep({ play, exit, clearLoading: choiceClearLoading, toggleEPG });
            pause && pause();
        }
    }, 30000);

const PlayerControlsLogic = {
    onPlay,
    onPause,
    onRecording,
    onBackward,
    onForward,
    onSlide,
    sendMetric,
    sendDimension,
    hasTimeshift,
    withTimeshiftEvent,
    getContentDuration,
    getPercentProgress,
    getPercentProgressEvent,
    getCurrentTimeAsStringStartover /* for startover */,
    getDurationAsStringStartover /* for startover */,
    setIntervalModalReproduction,
    resetDataModalSleep,
    showModalSleep,
    setValueStatePlaying,
    intervalValuesMetadata,
};

export default PlayerControlsLogic;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsLogic.js